import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Eye, Sparkles } from 'lucide-react';
export function TruthSection() {
  return <section className="py-24 bg-gradient-to-br from-gray-50 to-rose-50" data-id="element-263">
      <div className="max-w-5xl mx-auto px-6" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-266">
            A Verdade Cruel que Ninguém Te Contou Sobre Lembrancinhas
          </h2>
        </motion.div>

        <div className="space-y-8 mb-16" data-id="element-267">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-268">
            <div className="flex items-start gap-4" data-id="element-269">
              <TrendingUp className="w-8 h-8 text-rose-500 flex-shrink-0 mt-1" data-id="element-270" />
              <div data-id="element-271">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-272">
                  A indústria de casamento é superfaturada
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-273">
                  Coisas simples custam{' '}
                  <span className="font-bold text-rose-600" data-id="element-274">5x mais</span> só
                  porque são "para casamento". Um potinho que custa R$0,50 vira
                  R$3,00. Uma tag impressa que custa R$0,10 vira R$1,50. E você
                  paga porque não sabe que existe outro caminho.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-275">
            <div className="flex items-start gap-4" data-id="element-276">
              <Eye className="w-8 h-8 text-rose-500 flex-shrink-0 mt-1" data-id="element-277" />
              <div data-id="element-278">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-279">
                  Não é culpa sua não saber o que escolher
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-280">
                  O Pinterest te mostra 10.000 opções, mas nenhuma te ensina{' '}
                  <span className="font-bold" data-id="element-281">como fazer parecer caro</span>.
                  Você fica perdida entre tanta coisa linda e impossível, sem
                  saber por onde começar.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-282">
            <div className="flex items-start gap-4" data-id="element-283">
              <Sparkles className="w-8 h-8 text-rose-500 flex-shrink-0 mt-1" data-id="element-284" />
              <div data-id="element-285">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-286">
                  O que realmente importa é aparência profissional, não preço
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-287">
                  Ninguém vai perguntar quanto você gastou. Mas todo mundo vai{' '}
                  <span className="font-bold" data-id="element-288">notar se ficou bonito</span>. E é
                  exatamente aí que entra o segredo.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}